import { useState } from 'react'
import config from '../config.json'
import Translation from '../../Translation/cont/Translation';
import checkForAttributeMapping from '../../../functions/checkForAttributeMapping';
import AttributeIcon from './AttributeIcon';

const ItemAttributes = ({attributes, accentColorDark, translation, chosen_font, accentColor, themeColors, iconsColor, hide2d=false}) => {
    return attributes.map((attribute, index) => {
        const id = String(attribute.id)
        const {name} = attribute 
        let style
        let styleThird
        let styleFourth
        let styleFifth
        let styleSixth
        
        if(id !== 'fsk' && id !== 'length') {
            
            if(hide2d && (id === '1087' || id === '2d' || id === 'digital')) {
                return ''
            }

            if(attribute.colorSettings) {
                 if(attribute.displaySetting === "border") {
                    style = {
                        border: '1px solid ' +  attribute.colorSettings,    
                    }
                } else {
                    style = {
                        backgroundColor: attribute.colorSettings,    
                    }
                }
            } else {
                const coloring = attribute.colorToUse === 1 ? accentColorDark : attribute.colorToUse === 2 ? accentColor : attribute.colorToUse === 3 ? accentColor : accentColorDark
                 if(attribute.displaySetting === "border") {
                    style = {
                        border: '1px solid ' +  coloring,   
                        filter: attribute.styleFilter 
                    }
                } else {
                    style = {
                        backgroundColor: coloring,
                        filter: attribute.styleFilter
                    }
                }
            }

            if(attribute.displaySetting === "border") {
                const coloring = attribute.colorSettings ? attribute.colorSettings : attribute.colorToUse === 1 ? accentColorDark : attribute.colorToUse === 2 ? accentColor : attribute.colorToUse === 3 ? accentColor : accentColorDark
                if(attribute.colorToUse === 1) {
                    styleThird = {
                        borderColor: 'transparent transparent ' +  coloring + ' transparent'
                    }
                } else if(attribute.colorToUse === 2) {
                    styleFourth = {
                        borderColor: 'transparent transparent transparent ' +  coloring,
                        filter: attribute.colorSettings ? "none" : "sepia(1)"
                    }
                }  else if(attribute.colorToUse === 3) {
                    styleFifth = {
                        borderColor: 'transparent ' + coloring + ' transparent transparent',
                        filter: attribute.colorSettings ? "none" : "sepia(1) invert(1) brightness(1.5)"
                    } 
                } else {
                    styleSixth = {
                        borderColor: coloring + ' transparent transparent transparent',
                        filter: attribute.colorSettings ? "none" : "invert(1)"
                    }
                }
            }
        }
    
        const attributesName = (id !== 'fsk' && id !== 'length') ? checkForAttributeMapping(name, translation) : name
        const logoClass = _.contains(config.attributesWithIcons, id) ? 'attribute-logo ' + iconsColor + '-attribute': 'other-attribute'
        const doNotDisplayTitle = _.contains(config.attributesWithIcons, id) ? 'screen-reader-text ' : ''

        return (
            <div key={index} className={'attribute'}>
                <div style={style} className={'border-element ' + id}></div>
                <span data-attribute={id} className={logoClass}>
                    <span className={doNotDisplayTitle + `${chosen_font}-text-xsmall-light`}>
                        {id === 'fsk' && <Translation id="movie_attributes_fsk" after=' '/>}
                        {attributesName}
                        {id === 'length' &&  <Translation id="movie_attributes_length_unit"  before=' '/>}
                    </span>
                    {_.contains(config.attributesWithIcons, id) && <AttributeIcon attributeId={id} />}
                </span>
                {styleThird && <div style={styleThird} className="others-styling item-1 attribute-border"></div>}
                {styleFourth && <div style={styleFourth} className="others-styling item-2 attribute-border"></div>}
                {styleFifth && <div style={styleFifth} className="others-styling item-3 attribute-border"></div>}
                {styleSixth && <div style={styleSixth} className="others-styling item-4 attribute-border"></div>}
            </div>
        )
    })
}

export default ItemAttributes